<template>
  <div>
    <h1>{{title}}</h1>
    <el-button
        class="submit_page"
        type="blue"
        @click="Back()"

    >
      <span>Back to app</span>
    </el-button>
  </div>

</template>
<style scoped>

</style>

<script>



import {useRouter} from "vue-router";
import {onMounted} from "vue";
export default {


  setup() {
    const $router = useRouter();


    onMounted(async () => {

    });
    const title = "Failed"
    const Back = () => {
      $router.push({name: 'home'})
    }
    return {
      title,
      Back
    };
  },
};
</script>
